// The Wingman chat button: a speech bubble with the Wingman mark inside. Lane 1355 made a
// round Wingman button for the Meeting Prep deck (Ryan 2026-10-01: "a little Wingman chat
// bubble" in place of the "Chat" tab); Lane 1362 shared it with the sourcing event
// workspace and the Quoting page uses it too. Lane 1390 (Ryan, 2026-10-05): it looks like
// a chat bubble, and it shows only while the chat is closed, on every page. An open chat
// closes from its own X (or Escape), and the bubble comes back.
import React, { forwardRef } from 'react';
import WingmanLogo from '../WingmanLogo';
import '../../pages/ListLinear.css';     // the palette tokens (declared on .ll and .wchat)
import './workspaceChat.css';

//: A rounded box with a tail at its lower left, in a 48 x 48 box.
const BUBBLE_PATH = 'M10 3H38A8 8 0 0 1 46 11V29A8 8 0 0 1 38 37H21L10 45V37A8 8 0 0 1 2 29V11A8 8 0 0 1 10 3Z';

const ChatBubble = forwardRef(function ChatBubble({ open, onToggle, controls }, ref) {
  if (open) return null;
  return (
    <button ref={ref} type="button" className="wchat wchat-bubble"
      aria-label="Open Wingman chat" title="Open Wingman chat" aria-expanded={false}
      aria-controls={controls} onClick={onToggle}>
      <svg aria-hidden="true" className="wchat-bubble-shape" viewBox="0 0 48 48">
        <path d={BUBBLE_PATH} />
      </svg>
      {/* A solid fill: the gradient ids of the logo are page-global. */}
      <span aria-hidden="true" className="wchat-bubble-mark">
        <WingmanLogo size={24} fill="#fff" />
      </span>
    </button>
  );
});

export default ChatBubble;
